var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgFacilityParking = function SvgFacilityParking(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.9134221,58.0021733 L44.956544,58.0021733 L44.956544,80 L34,80 L34,25 L55.9134221,25 C66.7332559,25 72,32.554265 72,41.4953735 C72,50.4367063 67.8502245,57.9909711 57.0192489,57.9909711 L55.9134221,57.9909711 L55.9134221,58.0021733 Z M50.000111,0 C22.3825324,0 0,22.378886 0,49.9998333 C0,77.609668 22.3825324,100 50.000111,100 C77.6173565,100 100,77.609779 100,49.9998333 C100,22.378886 77.6173565,0 50.000111,0 Z M55.6688865,36 L45,36 L45,47 L55.6688865,47 C60.1755524,47 60.9973629,45.7853922 60.9973629,41.500056 C60.9973629,37.2147198 61.2528561,36.000112 56.7342561,36.000112 L55.6688865,36.000112 L55.6688865,36 Z"
  })))));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgFacilityParking);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "facility-parking.898602801bc49abc7eaf11af146e1b21.svg";